import * as actions from './settings.actions'

const initialState = {
  soundEffects: true,
  soundMusic: true,
  soundVoices: true,
  soundBackground: true,
  mineDisclaimer: false,
  locale: null,
  availableLanguages: [],
  showOnlyHelp: false,
  shadows: true,
}

const actionsMap = {
  // [actions.SELECT_LANGUAGE]: (state, action) => {
  //   const lang = action.data
  //
  //   return {
  //     ...state,
  //     locale: lang,
  //   }
  // },
  [actions.SET_LANGUAGES]: (state, action) => {
    const languages = action.data
    return {
      ...state,
      availableLanguages: languages,
    }
  },
  [actions.TOGGLE_SHADOWS]: (state) => {
    let current = state.shadows
    return {
      ...state,
      shadows: !current,
    }
  },
  [actions.SHOW_HELP]: (state) => {
    console.log(!state.showOnlyHelp)
    return {
      ...state,
      showOnlyHelp: !state.showOnlyHelp,
    }
  },

  [actions.SET_SOUND_BACKGROUND]: (state, action) => {
    const soundBackground = action.data

    return {
      ...state,
      soundBackground: soundBackground,
    }
  },
  [actions.SET_SOUND_EFFECTS]: (state, action) => {
    const soundEffects = action.data

    return {
      ...state,
      soundEffects: soundEffects,
    }
  },
  [actions.SET_SOUND_MUSIC]: (state, action) => {
    const soundMusic = action.data

    return {
      ...state,
      soundMusic: soundMusic,
    }
  },
  [actions.SET_MINE_DISCLAIMER]: (state) => {
    const mineDisclaimer = state.mineDisclaimer

    return {
      ...state,
      mineDisclaimer: !mineDisclaimer,
    }
  },
  [actions.SET_SOUND_MUSIC]: (state, action) => {
    const soundMusic = action.data

    return {
      ...state,
      soundMusic: soundMusic,
    }
  },
  [actions.SET_SOUND_VOICES]: (state, action) => {
    const soundVoices = action.data

    return {
      ...state,
      soundVoices: soundVoices,
    }
  },
  // Synchronization with savePoint
  [actions.SYNC_SETTINGS_FROM_SAVEPOINT]: (state, action) => {
    const settings = action.data
    return {
      ...state,
      soundMusic: settings.soundMusic,
      soundEffects: settings.soundEffects,
      soundVoices: settings.soundVoices,
      soundBackground: settings.soundBackground,
      mineDisclaimer: settings.mineDisclaimer || false,
      locale: settings.locale || initialState.locale,
      shadows: settings.shadows,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
